import { tJosa } from '@mathflat/shared/i18n/tJosa'

import commonRepo from '@/repository/common.repo'

import { MAX_WRONG_CLINIC_PAGE_COUNT_BY_ACADEMY_GROUP_WORKBOOK } from './makeWorksheet'

export const TOAST_STR = {
  // 공용
  err: '에러가 발생하였습니다.',
  delete: `삭제되었습니다.`,
  escape: commonRepo.isSchoolflat
    ? `학생 이용권이 비활성화되었습니다.`
    : `학생 상태를 ‘퇴원’으로 변경했습니다.`,
  attend: commonRepo.isSchoolflat
    ? `학생 이용권이 활성화되었습니다.`
    : `학생 상태를 ‘재원’으로 변경했습니다.`,
  escapeAndAttend: commonRepo.isSchoolflat
    ? '이용권 상태가 변경되었습니다.'
    : '학생 상태가 변경되었습니다.',
  attendance: `출석했습니다.`,
  leaving: `퇴실했습니다.`,

  successTextport: '문자 전송 요청이 완료되었습니다.',
  failureTextPort: `저장된 연락처가 없습니다.\n먼저 연락처를 등록해주세요.`,
  successText: '저장된 연락처로 문자 발송을 요청했습니다.',

  studentDelete: `학생을 삭제했습니다.`,
  changeStudentInfo: '학생 정보를 저장했습니다.',
  deleteStudentInfo: '학생 정보를 삭제했습니다.',
  createStudent: '새로운 학생이 등록되었습니다.',

  changeTeacherInfo: '선생님 정보를 저장했습니다.',
  createTeacher: '선생님이 등록되었습니다.',
  deleteTeacher: '선생님 정보를 삭제했습니다.',
  deleteGroup: '삭제했습니다.',
  changeGroupInfo: '반 정보를 저장했습니다.',
  sendComplete: '문자를 전송 하는중입니다.',
  initPassword: '비밀번호가 초기화되었습니다.',
  updateTemplates: '저장했습니다.',

  // mypage
  changePassword: '비밀번호를 변경했습니다.',
  changeMyinfo: '계정 정보를 변경했습니다.',

  deleteQuestionInQA: '삭제했습니다.',
  deleteTemplate: '삭제했습니다.',
  changeClassName: '교육기관 이름을 저장했습니다.',
  changeLogoFile: '로고를 변경했습니다.',
  updateNotice: '공지를 등록했습니다.',
  deleteNotice: '공지사항이 삭제되었습니다.',
  createNotice: '공지를 수정하였습니다',
  createQna: '1:1 문의가 접수되었습니다.',

  assignWorksheet: () => `학습지가 ${tJosa('출제')}되었습니다.`,

  assignHomework: () => `학습지가 숙제로 ${tJosa('출제')}되었습니다.`,
  assignCas: () => `${tJosa('반응형평가', '이/가')} 숙제로 ${tJosa('출제')}되었습니다.`,
  assignAdditionalHomework: () =>
    `이미 ${tJosa('출제')}된 숙제 학습지를 제외하고,\n${tJosa('출제')}되지 않은 숙제만 ${tJosa('출제')}되었습니다.`,
  assignHomeworkToOtherStudents: () =>
    `${tJosa('출제')} 이력이 없는 학생에게\n학습지가 숙제로 ${tJosa('출제')}되었습니다.`,
  deleteHomework: '숙제가 삭제되었습니다.',

  changeScoring: '채점이 변경되었습니다.',

  // report
  changeReport: '보고서를 수정했습니다.',
  createReport: '보고서가 만들어졌습니다.',
  deleteReport: '보고서가 삭제되었습니다.',
  reportNotFound: '보고서가 삭제되어 다운로드할 수 없습니다.',
  openToParent: '보고서가 학부모앱에 공개되었습니다.',
  closeToParent: '보고서가 학부모앱에 비공개되었습니다.',
  openToCreverse: '보고서가 올림앱에 공개되었습니다.',
  closeToCreverse: '보고서가 올림앱에 비공개되었습니다.',
  openToCreverseFail: '올림앱 공개에 실패하였습니다.\n다시 시도해주세요.',
  closeToCreverseFail: '올림앱 비공개에 실패하였습니다.\n다시 시도해주세요.',
  openToCreversePartialFail: (count: number) =>
    `${count}개 보고서를 올림앱에 공개하지 못했습니다.\n다시 시도해주세요.`,
  closeToCreversePartialFail: (count: number) =>
    `${count}개 보고서를 올림앱에서 비공개하지 못했습니다.\n다시 시도해주세요.`,
  creatingReport: '보고서를 생성 중입니다.\n알림센터에서 확인해주세요.',
  updatingReport: '보고서를 수정 중입니다.\n알림센터에서 확인해주세요.',
  notAvailableReport: '채점 데이터가 없습니다.\n기간 혹은 학습기록을 다시 설정해주세요.',
  changeScoreDatetime: '채점일을 변경했습니다.',
  changeAssignDatetime: () => `${tJosa('출제')}일을 변경했습니다.`,
  createReportError: '보고서 생성에 실패하였습니다.',
  reportNotFoundForPreview: '보고서가 삭제되어 미리보기를 할 수 없습니다.',
  smsSendingFailed: '학부모 연락처가 없는 학생은 제외되었습니다.\n등록 후 재시도해 주세요.',

  // worksheet
  deleteWorksheet: '학습지가 삭제되었습니다.',
  createPiece: '학습지를 생성했습니다.',
  createWorksheetError: '학습지 생성에 실패했습니다.',
  notSelectStudent: '선택된 학생이 없습니다.',
  notSelectPiece: '선택한 문제지가 없습니다.',
  createProblemErrorReport: '문제 오류 신고가 접수되었습니다.',
  createConceptErrorReport: '개념 오류 신고가 접수되었습니다.',
  unassignWorksheet: () => `학습지가 ${tJosa('출제')} 취소되었습니다.`,
  curriculum09Group: '09개정으로 구성된 학습지는 오답학습지를 지원하지 않습니다.',
  qrUnavailable: '기능 업데이트 이전에 만든 학습지에는\nQR을 추가할 수 없습니다.',

  // workbook
  createWorkbookError: '교재 생성에 실패했습니다.',
  assignWorkbookHomework: () => `교재가 숙제로 ${tJosa('출제')}되었습니다.`,
  assignWorkbook: () => `교재가 ${tJosa('출제')}되었습니다.`,
  unassignWorkbook: () => `교재가 ${tJosa('출제')} 취소되었습니다.`,
  wrongClinicPageLimitSelect: `오답학습지는 최대 ${MAX_WRONG_CLINIC_PAGE_COUNT_BY_ACADEMY_GROUP_WORKBOOK}페이지까지 선택해서 만들 수 있어요.`,
  wrongClinicPageLimitInput: `오답학습지는 최대 ${MAX_WRONG_CLINIC_PAGE_COUNT_BY_ACADEMY_GROUP_WORKBOOK}페이지까지 선택할 수 있어요.`,
  // worksheet, workbook 공통
  notAutoScorableProblem: '이 문제는 자동 채점 문제가 아니므로 추가할 수 없습니다.',
  notAutoScorableProblemList: '자동 채점 문제가 아니므로 추가할 수 없습니다.',
  // error
  undefinedBook: '잘못된 파일입니다. 삭제 후 다시 등록해주세요.',
  errorMessage: '오류가 발생했습니다. 다시 시도해 주세요.',

  //modify
  modify: '변경 사항이 저장되었습니다.',
  customerTypeModify: '선택이 완료되었습니다.',

  // range
  minRange: '1개 이상의 범위를 선택해주세요.',

  // 발신번호 변경
  phoneAuthSuccess: '발신번호 변경이 완료되었습니다.',
  phoneAuthFail: '일시적인 오류로 인증에 실패했습니다. 다시 시도해주세요.',

  // 정산정보 입력
  settlementInfoRegisterAuthSuccess: '정산정보 본인인증이 완료되었습니다.',
  settlementInfoRegisterAuthFail: '정산정보 본인인증에 실패했습니다. 다시 시도해주세요.',
  settlementInfoRegisterSuccess: '정산정보 등록에 성공했습니다.',

  identificationAlreadyExist: '본인 인증에 실패했습니다. 다시 시도해주세요.',
  failedToMatchPhone: '본인 인증에 실패했습니다. 다시 시도해주세요.',
  failedToMatchName: '본인 인증된 이름과 계좌 소유주가 일치하지 않습니다. 다시 시도해주세요.',
  failedToValidateBankAccount: '계좌정보가 정확하지 않습니다. 다시 시도해주세요.',
  failedToValidateRealName: 'Nice 실명확인이 실패했습니다. 다시 시도해주세요.',
  identificationNotFound: '주민등록번호가 정확하지 않습니다. 다시 시도해주세요.',
  failedToGetNiceToken: '주민등록번호가 정확하지 않습니다. 다시 시도해주세요.',

  // 즐겨찾기
  addFavorite: '즐겨찾기에 추가되었습니다.',
  deleteFavorite: '즐겨찾기가 해제되었습니다.',

  // 즐겨찾기-표지
  favoriteTemplateMax: '즐겨찾는 표지는 최대 50개까지 추가할 수 있습니다.',

  // 즐겨찾기-문제
  addFavoriteProblem: '즐겨찾는 문제로 추가되었습니다.',
  deleteFavoriteProblem: '즐겨찾는 문제에서 제외되었습니다.',
  cannotSelectNonAutoScorableProblem: '상단 자동 채점 옵션을 OFF로 변경해주세요.',
  favoriteNotAllowed: '즐겨찾기가 되지 않는 문제입니다.',

  // 이메일
  startEmailSending: '이메일 전송을 시작하였습니다.',

  // notification
  expiredNotification: '읽은 후 5일이 지나 자동 삭제된 알림입니다.',

  // PODMall parent payment
  parentPaymentResendSuccess: '학부모에게 결제요청이 재발송되었습니다.',
  parentPaymentResendError: '재발송에 실패했습니다.',
  parentPaymentCancelSuccess: '결제요청이 취소되었습니다.',
  parentPaymentCancelError: '결제요청 취소에 실패했습니다.',

  // DownloadHistory
  downloadHistoryError: '다운로드 중 오류가 발생했습니다.',
} as const

export const str = ''
